class floatingCart extends HTMLElement {
  constructor() {
    super();
    this.revealFloatingCart();
    this.onVariantChange();
    // this.cehckBuyNowBtn();
    document.querySelector('html').style.setProperty('--floating-cart-height',`${this.clientHeight}px`);
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
  onScroll() {
    let atcObserver = new IntersectionObserver( (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          requestAnimationFrame(this.reset.bind(this));
        } else {
          requestAnimationFrame(this.reveal.bind(this));
        }
      });
    })
    atcObserver.observe(document.querySelector('.product-form.main-p-form .product-form__buttons'));
  }
  reveal() {
    this.setAttribute('animate', '');
  }
  reset() {
    this.removeAttribute('animate');
  }
  onVariantChange = () => {
    document.addEventListener('variant:change', (vardata) => {
      if(this.querySelector('.var-title')){
        this.querySelector('.var-title').textContent = vardata.detail.variant.title;
      }
      this.querySelector('.img-wrapper img').src = vardata.detail.variant.featured_image.src;
    })
  }
  
  revealFloatingCart = () => {
    window.addEventListener('scroll', () => {
      let crollPosition = window.pageYOffset;
      let formEle = document.querySelector('.product-form.main-p-form');
      let offset = (formEle.offsetTop + window.innerHeight) - 100;
      if (crollPosition >= offset) {
        this.classList.add('active')
      } else {
        this.classList.remove('active')
      }
    })
  } 

  cehckBuyNowBtn = () => {
    let buyNowBtnWrapper = this.querySelector('.paymentBtnWrapper');
    let checkBtnText = () => {
      let buyNowBtn = this.querySelector('.shopify-payment-button__button')
      if (buyNowBtn.textContent == 'Buy it now') buyNowBtn.textContent = 'Buy Now'
    }
    let btnObserver = new MutationObserver(checkBtnText);
    btnObserver.observe(buyNowBtnWrapper, {characterDataOldValue: true, childList: true, subtree: true})
  }

}
customElements.define('floating-cart',floatingCart)